import Icon from '@ant-design/icons/lib/components/Icon';

const active_theme = 'light';
const primary_color = 'cyan';

const hex = {
  light: {
    blue: {
      1: '#E6F4FF',
      2: '#BAE0FF',
      3: '#91CAFF',
      4: '#69B1FF',
      5: '#4096FF',
      6: '#1677FF',
      7: '#0958D9',
      8: '#003EB3',
      9: '#002C8C',
      10: '#001D66',
    },
    cyan: {
      1: '#E6FFFB',
      2: '#B5F5EC',
      3: '#87E8DE',
      4: '#5CDBD3',
      5: '#36CFC9',
      6: '#13C2C2',
      7: '#08979C',
      8: '#006D75',
      9: '#00474F',
      10: '#002329',
    },
    green: {
      1: '#F6FFED',
      2: '#D9F7BE',
      3: '#B7EB8F',
      4: '#95DE64',
      5: '#73D13D',
      6: '#52C41A',
      7: '#389E0D',
      8: '#237804',
      9: '#135200',
      10: '#092B00',
    },
    gold: {
      1: '#FFFBE6',
      2: '#FFF1B8',
      3: '#FFE58F',
      4: '#FFD666',
      5: '#FFC53D',
      6: '#FAAD14',
      7: '#D48806',
      8: '#AD6800',
      9: '#874D00',
      10: '#613400',
    },
    neutral: {
      white: '#ffffff',
      bgBase: '#ffffff',
      textBase: '#000000',
      transperant: '#00000000',

      text: 'rgba(0, 0, 0, 88%)',
      textSecondary: 'rgba(0, 0, 0, 65%)',
      textTertiary: 'rgba(0, 0, 0, 45%)',
      textQuaternary: 'rgba(0, 0, 0, 25%)',
      textLightSolid: '#ffffff',
      textHeading: 'rgba(0, 0, 0, 88%)',
      textLabel: 'rgba(0, 0, 0, 65%)',
      textDescription: 'rgba(0, 0, 0, 45%)',
      textDisabled: 'rgba(0, 0, 0, 25%)',
      textPlaceholder: 'rgba(0, 0, 0, 25%)',

      colorIcon: 'rgba(0, 0, 0, 45%)',

      bgLayout: '#f5f5f5',

      border: '#D9D9D9',
      borderSecondary: '#F0F0F0',
      split: 'rgba(0, 0, 0, 0.06)',
      error: '#ff4d4f',

      fillAlter: 'rgba(0, 0, 0, 0.02)',
    },
  },
  dark: {
    blue: {
      1: '#111A2C',
      2: '#112545',
      3: '#15325B',
      4: '#15417E',
      5: '#1554AD',
      6: '#1668DC',
      7: '#3C89E8',
      8: '#65A9F3',
      9: '#8DC5F8',
      10: '#B7DCFA',
    },
    cyan: {
      1: '#112123',
      2: '#113536',
      3: '#144848',
      4: '#146262',
      5: '#138585',
      6: '#13A8A8',
      7: '#33BCB7',
      8: '#58D1C9',
      9: '#84E2D8',
      10: '#B2F1E8',
    },
    green: {
      1: '#162312',
      2: '#1D3712',
      3: '#274916',
      4: '#306317',
      5: '#3C8618',
      6: '#49AA19',
      7: '#6ABE39',
      8: '#8FD460',
      9: '#B2E58B',
      10: '#D5F2BB',
    },
    gold: {
      1: '#2B2111',
      2: '#443111',
      3: '#594214',
      4: '#7C5914',
      5: '#AA7714',
      6: '#D89614',
      7: '#E8B339',
      8: '#F3CC62',
      9: '#F8DF8B',
      10: '#FAEDB5',
    },
    neutral: {
      white: '#ffffff',
      bgBase: '#000000',
      textBase: '#ffffff',
      transperant: '#ffffff00',

      text: 'rgba(255, 255, 255, 88%)',
      textSecondary: 'rgba(255, 255, 255, 65%)',
      textTertiary: 'rgba(255, 255, 255, 45%)',
      textQuaternary: 'rgba(255, 255, 255, 25%)',
      textLightSolid: '#ffffff',
      textHeading: 'rgba(255, 255, 255, 88%)',
      textLabel: 'rgba(255, 255, 255, 65%)',
      textDescription: 'rgba(255, 255, 255, 45%)',
      textDisabled: 'rgba(255, 255, 255, 25%)',
      textPlaceholder: 'rgba(255, 255, 255, 25%)',

      colorIcon: 'rgba(255, 255, 255, 45%)',

      bgLayout: '#000000',

      border: '#D9D9D9',
      borderSecondary: '#F0F0F0',
      split: 'rgba(0, 0, 0, 0.06)',
      error: '#ff4d4f',

      fillAlter: 'rgba(255, 255, 255, 0.04)',
    },
  },
};

const getActiveColor = (color, shade) => {
  return `${hex[active_theme][color][shade || '']}`;
};

const Colorhex = {
  light: {
    colorPrimary: getActiveColor(primary_color, '7'),
    colorPrimaryBg: getActiveColor(primary_color, '1'),
    colorPrimaryBgHover: getActiveColor(primary_color, '2'),
    colorPrimaryBorder: getActiveColor(primary_color, '3'),
    colorPrimaryBorderHover: getActiveColor(primary_color, '4'),
    colorPrimaryHover: getActiveColor(primary_color, '6'),
    colorPrimaryActive: getActiveColor(primary_color, '8'),
    colorPrimaryTextHover: getActiveColor(primary_color, '6'),
    colorPrimaryText: getActiveColor(primary_color, '7'),
    colorPrimaryTextActive: getActiveColor(primary_color, '8'),

    colorBgLayout: getActiveColor('neutral', 'bgLayout'),

    colorBorder: getActiveColor('neutral', 'border'),
    colorBorderSecondary: getActiveColor('neutral', 'borderSecondary'),
    colorSplit: getActiveColor('neutral', 'split'),

    colorWhite: getActiveColor('neutral', 'white'),
    colorBgBase: getActiveColor('neutral', 'bgBase'),
    colorTextBase: getActiveColor('neutral', 'textBase'),
    transperant: getActiveColor('neutral', 'transperant'),

    colorText: getActiveColor('neutral', 'text'),
    colorTextSecondary: getActiveColor('neutral', 'textSecondary'),
    colorTextTertiary: getActiveColor('neutral', 'textTertiary'),
    colorTextQuaternary: getActiveColor('neutral', 'textQuaternary'),
    colorTextLightSolid: getActiveColor('neutral', 'textLightSolid'),
    colorTextHeading: getActiveColor('neutral', 'textHeading'),
    colorTextLabel: getActiveColor('neutral', 'textLabel'),
    colorTextDescription: getActiveColor('neutral', 'textDescription'),
    colorTextDisabled: getActiveColor('neutral', 'textDisabled'),
    colorTextPlaceholder: getActiveColor('neutral', 'textPlaceholder'),

    colorIcon: getActiveColor('neutral', 'colorIcon'),

    colorFillAlter: getActiveColor('neutral', 'fillAlter'),

    colorWarning: getActiveColor('gold', '6'),
    colorError: getActiveColor('neutral', 'error'),
  },
  dark: {
    colorPrimary: getActiveColor(primary_color, '7'),
    colorPrimaryBg: getActiveColor(primary_color, '1'),
    colorPrimaryBgHover: getActiveColor(primary_color, '2'),
    colorPrimaryBorder: getActiveColor(primary_color, '3'),
    colorPrimaryBorderHover: getActiveColor(primary_color, '4'),
    colorPrimaryHover: getActiveColor(primary_color, '8'),
    colorPrimaryActive: getActiveColor(primary_color, '6'),
    colorPrimaryTextHover: getActiveColor(primary_color, '8'),
    colorPrimaryText: getActiveColor(primary_color, '7'),
    colorPrimaryTextActive: getActiveColor(primary_color, '6'),

    colorBgLayout: getActiveColor('neutral', 'bgLayout'),

    colorBorder: getActiveColor('neutral', 'border'),
    colorBorderSecondary: getActiveColor('neutral', 'borderSecondary'),
    colorSplit: getActiveColor('neutral', 'split'),

    colorWhite: getActiveColor('neutral', 'white'),
    colorBgBase: getActiveColor('neutral', 'bgBase'),
    colorTextBase: getActiveColor('neutral', 'textBase'),
    transperant: getActiveColor('neutral', 'transperant'),

    colorText: getActiveColor('neutral', 'text'),
    colorTextSecondary: getActiveColor('neutral', 'textSecondary'),
    colorTextTertiary: getActiveColor('neutral', 'textTertiary'),
    colorTextQuaternary: getActiveColor('neutral', 'textQuaternary'),
    colorTextLightSolid: getActiveColor('neutral', 'textLightSolid'),
    colorTextHeading: getActiveColor('neutral', 'textHeading'),
    colorTextLabel: getActiveColor('neutral', 'textLabel'),
    colorTextDescription: getActiveColor('neutral', 'textDescription'),
    colorTextDisabled: getActiveColor('neutral', 'textDisabled'),
    colorTextPlaceholder: getActiveColor('neutral', 'textPlaceholder'),

    colorIcon: getActiveColor('neutral', 'colorIcon'),

    colorFillAlter: getActiveColor('neutral', 'fillAlter'),

    colorWarning: getActiveColor('gold', '6'),
    colorError: getActiveColor('neutral', 'error'),
  },
};

const getColors = () => {
  const colors = {};
  Object.keys(Colorhex[active_theme]).forEach((key) => {
    colors[key] = Colorhex[active_theme][key];
  });
  return colors;
};

console.log(getColors());

const colors = getColors();

export default colors;
